export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex items-start justify-between mb-6" data-testid={testId}>
      <div>
        <h1 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
